import { viewStateKey, type Runtime } from "@baton/core";

/**
 * 018 FR-018-237, FR-018-282 as amended 2026-09-30 (the owner: "we want to make the calendar view the
 * default view ... move the calendar view to be before the list view"): the meetings list's two
 * layouts in the order every switch draws them, Calendar then List, and which one a visit opens. The
 * URL's `layout` wins, then the layout the Team last chose in this browser, then the Calendar. It
 * stands apart from `layout.ts` so the route's loading state (`routes/fallbacks.tsx`), which sits in
 * the initial chunk, draws the skeleton of the layout that will mount without loading the calendar's
 * model.
 */
export const MEETING_LAYOUTS = ["calendar", "list"] as const;
export type MeetingLayout = (typeof MEETING_LAYOUTS)[number];

/** The view-state scope the meetings list remembers its layout, views and switches under, per Team. */
export function meetingsScope(ws: string): string {
  return `meetings:${ws}`;
}

export function meetingLayoutOf(value: string | null | undefined): MeetingLayout | null {
  return MEETING_LAYOUTS.find((layout) => layout === value) ?? null;
}

export function chosenMeetingLayout(runtime: Runtime, ws: string, params: URLSearchParams): MeetingLayout {
  return meetingLayoutOf(params.get("layout")) ?? meetingLayoutOf(runtime.storage.get(viewStateKey, meetingsScope(ws))?.layout) ?? "calendar";
}
